/**
 * Constants for the Confirm Your Plan promotional banner.
 * Pricing values are hardcoded on the FE (no backend/config lookup) per plan decision.
 */

/** Length of one countdown cycle, in days. */
const PROMO_CYCLE_DAYS = 14;

/** Length of one countdown cycle, in milliseconds. */
export const PROMO_CYCLE_MS = PROMO_CYCLE_DAYS * 24 * 60 * 60 * 1000;

/** Original (strikethrough) price shown in the banner. */
export const PROMO_ORIGINAL_PRICE = 2000;

/** Discounted price shown in the banner. */
export const PROMO_DISCOUNT_PRICE = 1000;

/** localStorage key holding the countdown deadline (epoch ms) for a given account. */
export const promoDeadlineKey = (accountId: number): string => `k1.promoBanner.deadline.${accountId}`;
